import {NavigationGuard} from 'vue-router/types/router';
import {OrderStore, ERouteName} from '..';

export const RequireActiveLocationId: NavigationGuard = (to, from, next) => {
	if(OrderStore.selectedLocationId) {
		next();
	} else {
		next({
			name: ERouteName.Home,
			query: {chooseLocation: 'true'}
		});
	}
};
